"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionsSingle = void 0;
var react_1 = __importStar(require("react"));
var NoOptionResultsComp_1 = require("../NoOptionResultsComp");
var OptionContent_1 = require("../OptionContent");
var OptionsShell_1 = require("../OptionsShell");
var styled_1 = require("./styled");
var themes_1 = require("../../../../themes");
var Divider_1 = require("../../../Divider");
var TextInputs_1 = require("../../../TextInputs");
var TextLoader_1 = require("../../../LoadersAndProgress/TextLoader");
var useKeyboardControl_1 = require("../../utils/useKeyboardControl");
var useSetYOrientation_1 = require("../../utils/useSetYOrientation");
/**
 * if used independently, must be used inside a 'position: relative/absolute' div.
 */
var OptionsSingle = function (_a) {
    var 
    //from root
    lightboxHeight = _a.lightboxHeight, lightboxStyle = _a.lightboxStyle, optionsAnchor = _a.optionsAnchor, value = _a.value, id = _a.id, optionsClassName = _a.optionsClassName, 
    //from Dropdown
    relativeToRef = _a.relativeToRef, //the element that this lightbox is being rendered against. i.e top or bottom
    showOptions = _a.showOptions, handleHideOptions = _a.handleHideOptions, handleSelect = _a.handleSelect, options = _a.options, isSearchable = _a.isSearchable, label = _a.label, optionsModalLabel = _a.optionsModalLabel, //label is just a fallback for optionsModalLabel. Don't know why both are needed
    searchString = _a.searchString, setSearchString = _a.setSearchString, SelectComp = _a.SelectComp, genCreateTagButton = _a.genCreateTagButton, invert = _a.invert, popOutOfOverflowHiddenParent = _a.popOutOfOverflowHiddenParent, _b = _a.enableUseSetYOrientation, enableUseSetYOrientation = _b === void 0 ? true : _b, // if using this component standalone, this should be set to false ( if relativeToRef is not being passed thru)
    S = _a.S, observerRef = _a.observerRef, searchbarPlaceholder = _a.searchbarPlaceholder, alignDropdown = _a.alignDropdown
    //disabled only with this is being used for the RTEEmbedLightbox. Also this might be temp.
    //ensure this is set to false, if you are not passing a 'relativeToRef'
    ;
    //INIT ORIENTATION STATE AND CUSTOM HOOK
    var optionsRef = (0, react_1.useRef)(null);
    var yOrientation = (0, useSetYOrientation_1.useSetYOrientation)({
        showOptions: showOptions,
        optionsRef: optionsRef,
        relativeToRef: relativeToRef,
        enabled: enableUseSetYOrientation,
    }).yOrientation;
    var _c = (0, useKeyboardControl_1.useKeyboardControl)({
        showOptions: showOptions,
        optionsWrapperRef: optionsRef,
        handleHideOptions: handleHideOptions,
        handleSelect: handleSelect,
        options: options,
        searchString: searchString,
        id: id,
    }), scrollFocussedOpIntoView = _c.scrollFocussedOpIntoView, focussedOp = _c.focussedOp;
    var _d = (0, react_1.useState)(true), searchBarFocus = _d[0], setSearchBarFocus = _d[1];
    (0, react_1.useEffect)(function () {
        setSearchBarFocus(showOptions);
    }, [showOptions]);
    var genSearchBar = function () { return (react_1.default.createElement("div", { style: {
            position: "sticky",
            top: 0,
            zIndex: 1,
            background: invert ? themes_1.colors.greyColor90 : themes_1.colors.white,
        } },
        react_1.default.createElement("div", { style: { padding: "1rem" } },
            react_1.default.createElement(TextInputs_1.TextInput, { placeholder: searchbarPlaceholder, invert: invert, forceFocus: searchBarFocus, type: "text", icon: "MagnifyingGlass", value: searchString, onChange: function (k, v) { return setSearchString(v); }, S: S })),
        react_1.default.createElement(Divider_1.Divider, { invert: invert }))); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(OptionsShell_1.OptionsShell, { ref: optionsRef, yOrientation: yOrientation, lightboxHeight: lightboxHeight, lightboxStyle: lightboxStyle, options: options, optionsAnchor: optionsAnchor, showOptions: showOptions, SelectComp: SelectComp, handleHideOptions: handleHideOptions, label: label, optionsModalLabel: optionsModalLabel, invert: invert, relativeToRef: relativeToRef, popOutOfOverflowHiddenParent: popOutOfOverflowHiddenParent, alignDropdown: alignDropdown, S: S },
            isSearchable && genSearchBar(),
            options.length === 0 ? (react_1.default.createElement(NoOptionResultsComp_1.NoOptionResultsComp, { S: S })) : (react_1.default.createElement(react_1.Fragment, null, options.map(function (option, index) { return (react_1.default.createElement(styled_1.StyledOption, { key: option.value, invert: invert, isSelected: !option.loading && (value === null || value === void 0 ? void 0 : value.value) === option.value, isFocussed: focussedOp === index, className: "OKE-Dropdown__option", ref: function (el) {
                    return focussedOp === index && el && scrollFocussedOpIntoView(el);
                }, onClick: function (e) {
                    if (!option.loading)
                        handleSelect(option);
                    setSearchString && setSearchString("");
                }, S: S }, option.loading ? (react_1.default.createElement(TextLoader_1.TextLoader, { style: { width: "8rem", height: "1.5rem" } })) : (react_1.default.createElement(OptionContent_1.OptionContent, { option: option, optionsClassName: optionsClassName, invert: invert, S: S, observerRef: options.length === index + 1 ? observerRef : null })))); }))),
            genCreateTagButton && genCreateTagButton(options))));
};
exports.OptionsSingle = OptionsSingle;
